// extracted by mini-css-extract-plugin
export default {"grid":"ia_Dtb2P5LUqYWEzMt3x"};